const TOKEN_NAME = 'synkedup_token'

export function getChatBase(): string {
  const env = window.env as any
  const apiEndpoint: string = env?.API_ENDPOINT ?? ''

  // Derive chat API URL from main API URL
  // http://localhost:52189/api → http://localhost:8001/chat
  // https://api-staging.synkedup.com/api → https://chat-api-staging.synkedup.com/chat
  // https://api.synkedup.com/api → https://chat-api.synkedup.com/chat
  try {
    const url = new URL(apiEndpoint)
    if (url.hostname === 'localhost') {
      url.port = '8001'
    } else {
      url.hostname = url.hostname.replace(/^api/, 'chat-api')
    }
    url.pathname = '/chat'
    return url.toString().replace(/\/$/, '')
  } catch {
    return apiEndpoint.replace(/\/api\/?$/, '/chat')
  }
}

/** The chat service's auth header for `token`, or none without one. */
export function authHeaders(token: string | null): Record<string, string> {
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export function getAccessToken(): string | null {
  try {
    const raw = localStorage.getItem(TOKEN_NAME)
    if (!raw) {
      return null
    }
    const token = JSON.parse(raw)
    if (token?.access_token && new Date(token.expires) > new Date()) {
      return token.access_token
    }
  } catch { /* empty */ }
  return null
}
